// Initial state
const initialState = {
  language: "en", // Default language is English
};

// Action types
const SET_LANGUAGE = "SET_LANGUAGE";

// Action creator
export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
});

// Reducer
const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
